<template>
    <div>
        <div class="squire-wrap"
             :class="{
                 'border-green': color === 'GREEN',
                 'border-red': color === 'RED',
                 'border-gray': color === 'GREY'
             }">
            <div class="squire"
                 :class="{
                     'bg-green': color === 'GREEN',
                     'bg-red': color === 'RED',
                     'bg-gray': color === 'GREY'
                 }">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'AppColoredSquire',
    props: {
        color: {type: String, default: 'GREEN'}
    }
}
</script>
<style scoped lang="scss">
    label, h4 {
        color: $color-purple-light;
    }

    input[type=date] {
        width: 100%;
    }

    button {
        width: 100px;
    }

    .squire {
        width: 11px;
        height: 11px;
        margin: 2px;
    }

    .squire-wrap {
        width: 17px;
        height: 17px;
    }

    .border-green {
        border: 1px solid #72BB53;
    }

    .bg-green {
        background: #72BB53;
    }

    .border-red {
        border: 1px solid red;
    }

    .bg-red {
        background: red;
    }

    .border-gray {
        border: 1px solid lightgray;
    }

    .bg-gray {
        background: lightgray;
    }
</style>
